import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calendar, TrendingUp, Heart, DollarSign, Brain, ShieldCheck } from 'lucide-react';
const resources = [{
  icon: Calendar,
  title: '1. Guía Práctica de 30 Días',
  desc: 'Tu hoja de ruta diaria. Solo 15 minutos al día para transformar tus finanzas sin agobios.',
  image: 'https://cdn.magicpatterns.com/uploads/rEbP9cdsB5wKXX71QsCx5Z/portada_finanzas_faciles.png'
}, {
  icon: BookOpen,
  title: '2. Diario de Dinero en Acción',
  desc: 'Plantillas imprimibles para rastrear tus gastos y descubrir tus fugas de dinero.',
  image: 'https://cdn.magicpatterns.com/uploads/skbL3ibVy7bjUqX578naJR/portada_bono_4.png'
}, {
  icon: ShieldCheck,
  title: '3. Plan para Salir de Deudas',
  desc: 'Estrategias probadas (bola de nieve y avalancha) explicadas para principiantes.',
  image: 'https://cdn.magicpatterns.com/uploads/aqaWhvwqXbR7suvdSC7kHY/portada_bono2.png'
}, {
  icon: TrendingUp,
  title: '4. Ahorro con Propósito',
  desc: 'Cómo construir tu fondo de emergencia y ahorrar para tus sueños, aunque ganes poco.',
  image: 'https://cdn.magicpatterns.com/uploads/mXmUYZXmhYUCQtpTiNT7mX/portada_bono3.png'
}, {
  icon: Heart,
  title: '5. Dinero en Pareja y Familia',
  desc: 'Guiones y consejos para hablar de dinero sin pelear y construir metas juntos.',
  image: 'https://cdn.magicpatterns.com/uploads/82pjW85xD7qLnv8WLUSVLA/portada_bono1.png'
}, {
  icon: DollarSign,
  title: '6. Obtén Ingresos Extra',
  desc: '20 ideas prácticas para generar dinero adicional desde casa esta misma semana.',
  image: 'https://cdn.magicpatterns.com/uploads/iowyRuUA8sVcfFG7ZcY8wE/portada_bono_5.png'
}, {
  icon: Brain,
  title: '7. Mentalidad de Abundancia',
  desc: 'Afirmaciones y ejercicios para romper bloqueos mentales sobre el dinero.',
  image: 'https://cdn.magicpatterns.com/uploads/dsMDdhavFW6Br34VYUL9Sg/portada_bono_6.png'
}];
export function HowItWorks() {
  return <section className="py-20 bg-white" data-id="element-372">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-373">
        <div className="text-center mb-16" data-id="element-374">
          <span className="text-[#d4a574] font-bold tracking-wider uppercase text-sm" data-id="element-375">
            ¿Qué incluye el pack?
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1e3a5f] mt-2 mb-4" data-id="element-376">
            Un sistema completo de 7 pasos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-377">
            No es solo información, es transformación. Cada recurso está
            diseñado para atacar un área específica de tu vida financiera.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-378">
          {resources.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`rounded-xl border border-gray-100 shadow-lg hover:shadow-xl transition-all overflow-hidden ${index === 0 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-379">
              <div className="relative group" data-id="element-380">
                <img src={item.image} alt={item.title} className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-381" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f] via-[#1e3a5f]/50 to-transparent opacity-90" data-id="element-382"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white" data-id="element-383">
                  <h3 className="text-xl font-serif font-bold mb-2" data-id="element-384">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-200" data-id="element-385">{item.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 bg-[#f4e4d7]/30 rounded-2xl p-8 md:p-12 text-center border border-[#d4a574]/20" data-id="element-386">
          <h3 className="text-2xl font-serif font-bold text-[#1e3a5f] mb-4" data-id="element-387">
            ¿Cómo funciona el reto de 30 días?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8" data-id="element-388">
            <div className="relative" data-id="element-389">
              <div className="w-10 h-10 bg-[#1e3a5f] text-white rounded-full flex items-center justify-center font-bold mx-auto mb-4 z-10 relative" data-id="element-390">
                1
              </div>
              <div className="hidden md:block absolute top-5 left-1/2 w-full h-0.5 bg-[#d4a574]/30 -z-0" data-id="element-391" />
              <h4 className="font-bold text-[#1e3a5f] mb-2" data-id="element-392">
                Lee la lección diaria
              </h4>
              <p className="text-sm text-gray-600" data-id="element-393">
                Lecturas cortas y motivadoras de 5 minutos.
              </p>
            </div>
            <div className="relative" data-id="element-394">
              <div className="w-10 h-10 bg-[#1e3a5f] text-white rounded-full flex items-center justify-center font-bold mx-auto mb-4 z-10 relative" data-id="element-395">
                2
              </div>
              <div className="hidden md:block absolute top-5 left-1/2 w-full h-0.5 bg-[#d4a574]/30 -z-0" data-id="element-396" />
              <h4 className="font-bold text-[#1e3a5f] mb-2" data-id="element-397">
                Haz el ejercicio práctico
              </h4>
              <p className="text-sm text-gray-600" data-id="element-398">
                Aplica lo aprendido inmediatamente en tu vida.
              </p>
            </div>
            <div className="relative" data-id="element-399">
              <div className="w-10 h-10 bg-[#1e3a5f] text-white rounded-full flex items-center justify-center font-bold mx-auto mb-4 z-10 relative" data-id="element-400">
                3
              </div>
              <h4 className="font-bold text-[#1e3a5f] mb-2" data-id="element-401">
                Celebra tu progreso
              </h4>
              <p className="text-sm text-gray-600" data-id="element-402">
                Siente la paz de tener el control día a día.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}